//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "infoShObj", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_add: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      dynamicValAddForm: {
        receiver: "",
        telphone: "",
        // area: "",
        addr: "",
        orderId: "",
        // code: "",
      },
      checked1: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_add = this.openStatus;
    },
    "$store.state.szStatus.receiverObj": {
      deep: true,
      handler(newValue, oldValue) {
        this.dynamicValAddForm = newValue;
        this.dynamicValAddForm.orderId = this.orderId;
      },
    },
    orderId(val1, val2) {
      this.dynamicValAddForm.orderId = val1;
    },
  },
  // created() {
  //   // this.dynamicValAddForm = JSON.parse(sessionStorage.getItem("infoShObj"))[0];
  //   this.dynamicValAddForm.orderId = this.orderId;
  // },
  mounted() {
    console.log(this.orderId);
    this.dynamicValAddForm = this.$store.state.szStatus.receiverObj;
    this.dynamicValAddForm.orderId = sessionStorage.getItem("orderId");
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.cancelOrderList();
        } else {
          return false;
        }
      });
    },
    // 修改收货人信息接口
    cancelOrderList() {
      this.stepLoading = true;
      this.$http.szOrder.editConsignee(this.dynamicValAddForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_add = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "修改成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_add = false;
      this.$emit("closeStatus", true);
    },
  },
};
